import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import actions from 'actions';
import constants from 'constants';
import validator from 'services/validator';
import inputFormatter from '../../../services/superhostInputFormatter';
import NewSuperhostForm from '../../../components/Admin/Superhosts/NewSuperhostForm';

const {
  CREATE_SUPERHOST
} = constants;

const {
  createSuperhost,
  getStudygroupsAdmin,
  cleanErrors,
} = actions;

class NewSuperhost extends Component {
  static propTypes = {
    createSuperhost: PropTypes.func,
    cleanErrors: PropTypes.func,
    dispatch: PropTypes.func,
    errors: PropTypes.obj,
    errorsFrontend: PropTypes.obj
  };

  constructor(props) {
    super(props);
    this.state = {
      superhost: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        validFrontend: false,
        role: 'superhost',
		    host_group_ids: [],
      }
    }
  }

  componentWillMount() {
    this.props.cleanErrors();
    this.props.loadStudygroups({}, 'all');
  }

  onFieldChange = (e) => {
    const input = inputFormatter.formatField(e.target.name, e.target.value);
    const superhostData = { ...this.state.superhost,
      ...{
        [e.target.name]: input
      }
    }

    this.setState({ superhost: superhostData });
  }

  onSubmit = () => {
    this.props.createSuperhost(this.state.superhost)
  }

  render() {
    const {
      errors,
      errorsFrontend,
      studygroups,
    } = this.props;
    const groups = (studygroups || []).map(group => ({value: group.id, label: group.title}));
    return (
      <main className="site--width clearfix-c">
        <NewSuperhostForm
          onFieldChange={this.onFieldChange}
          superhost={this.state.superhost}
          onSubmit={this.onSubmit}
          studyGroups={groups}
          errors={validator.formatErrors(errors, errorsFrontend)}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors[CREATE_SUPERHOST],
    errorsFrontend: state.errors[`${CREATE_SUPERHOST}_FRONTEND`],
    studygroups: state.studygroups.studygroups.values,
    query: state.studygroups.studygroups.query,
    page: state.studygroups.studygroups.page,
    total_pages: state.studygroups.studygroups.total_pages,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createSuperhost: (superhost) => dispatch(createSuperhost(superhost)),
    cleanErrors: () => dispatch(cleanErrors(CREATE_SUPERHOST)),
    loadStudygroups: (query, page) => dispatch(getStudygroupsAdmin(query, page)),
    dispatch: dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewSuperhost);



// WEBPACK FOOTER //
// ./src/containers/Admin/Superhosts/NewSuperhost.jsx